import React from 'react';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  List,
  ListItem,
  Typography,
} from '@mui/material';

const bs3 = {
  btnPrimary: {
    bgcolor: '#337ab7',
    color: '#fff',
    border: '1px solid #2e6da4',
    borderRadius: '4px',
    px: 2,
    py: 0.8,
    fontSize: '13px',
    fontWeight: 400,
    textTransform: 'none',
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    '&:hover': { bgcolor: '#286090', borderColor: '#204d74' },
  },
  btnDefault: {
    bgcolor: '#fff',
    color: '#333',
    border: '1px solid #ccc',
    borderRadius: '4px',
    px: 2,
    py: 0.8,
    fontSize: '13px',
    fontWeight: 400,
    textTransform: 'none',
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    '&:hover': { bgcolor: '#e6e6e6', borderColor: '#adadad' },
  },
  text: {
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    fontSize: '13px',
    color: '#333',
  },
};

/**
 * SerialDialog — Dialog pemilihan serial number untuk barang retail.
 *
 * Props:
 *   open              : boolean
 *   onClose           : () => void
 *   pendingProduct    : object — produk yang sedang dipilih serial-nya
 *   serialOptions     : array — daftar serial number tersedia
 *   serialSelection   : array — uuid serial yang dipilih
 *   setSerialSelection: setter
 *   onConfirm         : () => void — konfirmasi pemilihan serial
 */
const SerialDialog = ({
  open,
  onClose,
  pendingProduct,
  serialOptions = [],
  serialSelection = [],
  setSerialSelection,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          bgcolor: '#f5f5f5',
          borderBottom: '1px solid #ddd',
          fontSize: '15px',
          fontWeight: 700,
          fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        }}
      >
        Pilih Serial Number
      </DialogTitle>

      <DialogContent sx={{ pt: '16px !important' }}>
        <Typography sx={{ ...bs3.text, mb: 2 }}>
          Pilih serial number untuk barang{' '}
          <strong>{pendingProduct?.Barang?.namabarang || '-'}</strong>.
        </Typography>

        <List>
          {serialOptions.map((option) => (
            <ListItem
              key={option.uuid}
              disableGutters
              sx={{ borderBottom: '1px solid #f0f0f0', py: 0.5 }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serialSelection.includes(option.uuid)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSerialSelection((prev) => [...prev, option.uuid]);
                      } else {
                        setSerialSelection((prev) =>
                          prev.filter((item) => item !== option.uuid)
                        );
                      }
                    }}
                    size="small"
                  />
                }
                label={
                  <Typography sx={bs3.text}>
                    {option.serialNumber}{' '}
                    {option.kodeBarang ? `(${option.kodeBarang})` : ''}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>

      <DialogActions sx={{ borderTop: '1px solid #ddd', p: 1.5 }}>
        <Button onClick={onClose} sx={bs3.btnDefault}>
          Batal
        </Button>
        <Button onClick={onConfirm} sx={bs3.btnPrimary}>
          Tambahkan
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SerialDialog;
